// The Main Site Object
window.Site = {

    leftEye  : document.querySelector('.leye'),
    rightEye : document.querySelector('.reye'),

    // Init Function
    liftoff : () => {
        //Site.onClickRemoveCookieBanner()
        //Site.onLoadDisplayCookieBanner()

        Site.animateEyes()
    },

    // Generate The Cookie Banner
    onClickRemoveCookieBanner : () => {

        if (!Site.cookieBannerButton) return;

        Site.cookieBannerButton.addEventListener('click' , () => {

            if (localStorage.banner !== 'displayed')
                localStorage.banner = 'displayed';

            // Remove The Banner
            document.querySelector('.gocciola').remove();

        })
    },

    // We need to create and display the cookie banner
    onLoadDisplayCookieBanner : () => {

        if (localStorage.banner !== 'displayed') {
            
            // Create the banner DOM 
            Site.banner = document.createElement('div');
            Site.banner.classList.add('gocciola');

            // The Left Column
            Site.bannerText = document.createElement('div');
            Site.bannerText.classList.add('gocciola-text');

            // The Right Column
            Site.bannerButton = document.createElement('div');
            Site.bannerButton.classList.add('gocciola-button');


            // We need to create the content for the two columns
            Site.bannerTextContent  = document.createElement('p')
            Site.bannerButtonContent = document.createElement('button')

            // Set the text message
            Site.bannerTextContent.innerHTML  = "We use cookies"
            Site.bannerButtonContent.innerHTML = "Ok"

            // Append the two columns to the main banner
            Site.bannerText.appendChild(Site.bannerLeftContent)
            Site.bannerButton.appendChild(Site.bannerRightContent)

            // Append the two columns to the main banner
            Site.banner.appendChild(Site.bannerText)
            Site.banner.appendChild(Site.bannerButton)

            // Append the banner to the body
            document.body.appendChild(Site.banner);

        }

    },

    animateEyes : () => {

        // Abort if we don't have the correct logo
        if (!Site.leftEye && !Site.rightEye) return;

        window.addEventListener('mousemove' , event => {

            // Calculate the percentage position
            let xPosition = 100 / window.innerWidth * event.clientX
            let yPosition = 100 / window.innerHeight * event.clientY

            // Move the Eyes accordingly
            let eyeY = (1 / 100 * yPosition);
            let eyeX = (6 / 100 * xPosition) - 3;
            
            Site.leftEye.style.transform = `translate(${eyeX}%,${eyeY}%)`;
            Site.rightEye.style.transform = `translate(${eyeX}%,${eyeY}%)`;
        })

    }


}

// Launch The Script
Site.liftoff()